// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// TODO. !!! C# STRUCT.
// Настройка маржинальных коэффициентов для фьючерсов  MARGIN_COEFFICIENT_GROUP(32) в инструмент мессадже.
export class MarginCoefficients {
    constructor() {
        /// может быть 0
        this.FuturesExpDay = 0;
        /// может быть 0
        this.FuturesExpMonth = 0;
        // может быть 0
        this.FuturesExpYear = 0;
        this.Futures_HOLD_MARGINGSIZE = 0;
        this.Futures_INIT_MARGINGSIZE = 0;
        this.Futures_INIT_MARGINGSIZE_OVERNIGHT = 0;
        this.Futures_HOLD_MARGINGSIZE_OVERNIGHT = 0;
        this.Futures_INIT_MARGINGSIZE_SHORT = 0;
        this.Futures_HOLD_MARGINGSIZE_SHORT = 0;
        this.Futures_INIT_MARGINGSIZE_OVERNIGHT_SHORT = 0;
        this.Futures_HOLD_MARGINGSIZE_OVERNIGHT_SHORT = 0;
        this.Futures_VAR_COEFF = 0;
        this.Futures_USE_VAR_ONLY_INTRADAY = false;
        this.Futures_VAR_COEFF_APPLYING = 0;
    }
}
